import styled from 'styled-components';
import BaseIconSvg from '@sdk/components/ui/BaseIconSvg';

import CloseSVG from '@web/assets/svg/UI/close.svg';

export const CloseIcon = styled(BaseIconSvg)``;
CloseIcon.defaultProps = { as: CloseSVG };

export const CloseButton = styled.button`
  background: transparent;
  border: 0;
  border-radius: 0;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;
  display: block;
  height: 24px;
  width: 24px;
  padding: 0;
  position: absolute;
  right: 3px;
  top: 3px;
`;

export const Wrapper = styled.div`
  z-index: 1;
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 8px;
  margin-bottom: -2px;
  border: 1px solid;
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-width: 0;
  border-color: ${(props) => props.theme.colors.separatorOnWhite};
`;

export const WrapperInner = styled.div`
  position: relative;
  border-radius: 2px;
  padding: 5px 20px 10px 10px;
  background-color: ${({ theme }) => theme.colors.bodyBg};
`;
